'use strict';

var clientSideValidation = require('../components/clientSideValidation');
var registrationFormHelpers = require('../components/registrationFormHelpers');

var currentStep = 1;
var selectedCustomerType = null;
var clubMemberChecked = false;
var $registrationForm;
var $continueButton;
var $backButton;
var $createAccountButton;

/**
 * Update button visibility based on current step
 * @param {number} stepNumber - Current step number
 */
function updateButtons(stepNumber) {
    if (stepNumber === 1) {
        $backButton.addClass('visually-hidden').attr('tabindex', '-1');
        if (clubMemberChecked && selectedCustomerType) {
            $continueButton.removeClass('visually-hidden').prop('disabled', false).attr('tabindex', '0');
            $createAccountButton.addClass('visually-hidden').attr('tabindex', '-1');
        } else {
            $continueButton.addClass('visually-hidden').attr('tabindex', '-1');
            $createAccountButton.removeClass('visually-hidden').attr('tabindex', '0');
        }
    } else if (stepNumber === 2) {
        $backButton.removeClass('visually-hidden').attr('tabindex', '0');
        $continueButton.removeClass('visually-hidden').prop('disabled', false).attr('tabindex', '0');
        $createAccountButton.addClass('visually-hidden').attr('tabindex', '-1');
    } else if (stepNumber === 3) {
        $backButton.removeClass('visually-hidden').attr('tabindex', '0');
        $continueButton.addClass('visually-hidden').attr('tabindex', '-1');
        $createAccountButton.removeClass('visually-hidden').prop('disabled', false).attr('tabindex', '0');
    }
}

/**
 * Show specific step and hide others
 * @param {number} stepNumber - Step number (1, 2, or 3)
 * @param {string} journeyType - Journey type for step 2 (business, smallArtisan, influencer)
 */
function showStep(stepNumber, journeyType) {
    // Enable all fields in all steps
    $('.registration-step').find('input, select, textarea').prop('disabled', false);

    // If we have a selected journey type, keep its Step 2 fields enabled even when on Step 3
    var selectedJourneyStep2Class = '';
    if (selectedCustomerType && selectedCustomerType !== 'homebaker' && selectedCustomerType !== 'other') {
        selectedJourneyStep2Class = 'step-2-' + selectedCustomerType;
    }

    // Show/hide journey selection wrapper and journey-other-group based on step number
    var $journeySelectionWrapper = $('.journey-selection-wrapper');
    var $journeyOtherGroup = $('.journey-other-group');

    if (stepNumber === 1) {
        // Show journey selection wrapper on step 1 if clubMember is checked
        if (clubMemberChecked) {
            $journeySelectionWrapper.removeClass('visually-hidden').addClass('show');
            // Show journey-other-group only if "other" is selected
            if (selectedCustomerType === 'other') {
                $journeyOtherGroup.removeClass('visually-hidden').addClass('show');
            } else {
                $journeyOtherGroup.removeClass('show').addClass('visually-hidden');
            }
        } else {
            $journeySelectionWrapper.removeClass('show').addClass('visually-hidden');
            $journeyOtherGroup.removeClass('show').addClass('visually-hidden');
        }
    } else {
        // Hide journey selection wrapper and journey-other-group on steps 2 and 3
        $journeySelectionWrapper.removeClass('show').addClass('visually-hidden');
        $journeyOtherGroup.removeClass('show').addClass('visually-hidden');
    }

    // Then, disable mandatory fields from steps/journey types that are not relevant to current step
    $('.registration-step').each(function () {
        var $step = $(this);
        var isVisible = false;
        var shouldDisableMandatory = false;

        // Determine if this step should be visible
        if (stepNumber === 1 && $step.hasClass('step-1')) {
            isVisible = true;
        } else if (stepNumber === 2 && journeyType && $step.hasClass('step-2-' + journeyType)) {
            isVisible = true;
        } else if (stepNumber === 3 && $step.hasClass('step-3')) {
            isVisible = true;
        } else if (!$step.hasClass('step-1')) {
            // This step is not visible and it's NOT Step 1
            // Check if it's the selected journey type's Step 2 - if so, keep it enabled
            var isSelectedJourneyStep2 = selectedJourneyStep2Class && $step.hasClass(selectedJourneyStep2Class);
            if (!isSelectedJourneyStep2) {
                // Only disable mandatory fields if it's NOT Step 1 and NOT the selected journey type
                shouldDisableMandatory = true;
            }
        }

        if (isVisible) {
            // Show step - all fields remain enabled
            $step.removeClass('visually-hidden');
            return;
        }

        // Hide step
        $step.addClass('visually-hidden');

        // Disable only mandatory fields in this hidden step (but never Step 1 fields or selected journey type)
        // Optional fields remain enabled so their values are still submitted
        if (shouldDisableMandatory && !$step.hasClass('step-1')) {
            $step.find('input[required], select[required], textarea[required]').prop('disabled', true);
            // Also disable fields marked as mandatory via class
            $step.find('.required input[required], .required select[required], .required textarea[required]').prop('disabled', true);
        }
    });

    updateButtons(stepNumber);
}

/**
 * Validate current step using clientSideValidation
 * Creates a temporary form with only visible fields from the current step
 * and validates it using SFRA's clientSideValidation module
 * @returns {boolean} True if step is valid
 */
function validateCurrentStep() {
    if (!$registrationForm || $registrationForm.length === 0) {
        return false;
    }

    // Get the current visible step container
    var $currentStep = $('.registration-step:not(.visually-hidden)');

    // Clear previous validation errors in current step
    clientSideValidation.functions.clearForm($currentStep[0]);

    // Use shared helper to create temporary form
    var tempFormData = registrationFormHelpers.createTempFormForValidation($currentStep);
    var $tempForm = tempFormData.tempForm;
    var fieldMapping = tempFormData.fieldMapping;

    // Validate the temporary form using clientSideValidation
    var isValid = clientSideValidation.functions.validateForm($tempForm[0], null);

    // Validate mandatory checkbox groups using global validation function
    var checkboxGroupsValid = clientSideValidation.functions.validateMandatoryCheckboxGroups($currentStep);
    if (!checkboxGroupsValid) {
        isValid = false;
    }

    // Validate mandatory radio button groups using global validation function
    var radioGroupsValid = clientSideValidation.functions.validateMandatoryRadioGroups($currentStep);
    if (!radioGroupsValid) {
        isValid = false;
    }

    // Map validation errors back to original fields (skip radio and checkbox as they're handled separately)
    registrationFormHelpers.mapValidationErrors(fieldMapping, { skipRadio: true, skipCheckbox: true });

    // Clear errors for valid fields
    fieldMapping.forEach(function (mapping) {
        var tempField = mapping.temp;
        var $originalField = $(mapping.original);
        if (tempField.validity.valid && tempField.type !== 'radio' && tempField.type !== 'checkbox') {
            $originalField.removeClass('is-invalid');
            $originalField.closest('.form-group').removeClass('has-invalid-field');
            $originalField.closest('.form-group').find('.invalid-feedback').hide();
        }
    });

    // Remove temporary form
    $tempForm.remove();

    if (currentStep === 1) {
        // Validate email match
        var $emailField = $('#registration-form-email');
        var $emailConfirmField = $('#registration-form-email-confirm');

        if ($emailField.length > 0 && $emailConfirmField.length > 0) {
            var emailValue = $emailField.val();
            var emailConfirmValue = $emailConfirmField.val();

            // Normalize email values (trim and convert to lowercase for comparison)
            if (emailValue && emailConfirmValue) {
                var normalizedEmail = emailValue.trim().toLowerCase();
                var normalizedEmailConfirm = emailConfirmValue.trim().toLowerCase();

                if (normalizedEmail !== normalizedEmailConfirm) {
                    isValid = false;
                    var emailMismatchMsg = $emailConfirmField.data('mismatch-error');
                    clientSideValidation.functions.showFieldError($emailConfirmField[0], emailMismatchMsg);
                }
            }
        }

        // Validate password match
        var $passwordField = $('input[type="password"][name*="password"]:not([name*="passwordconfirm"])');
        var $passwordConfirmField = $('input[type="password"][name*="passwordconfirm"]');

        if ($passwordField.length > 0 && $passwordConfirmField.length > 0) {
            var passwordValue = $passwordField.val();
            var passwordConfirmValue = $passwordConfirmField.val();

            if (passwordValue && passwordConfirmValue && passwordValue !== passwordConfirmValue) {
                isValid = false;
                var passwordMismatchMsg = $passwordConfirmField.data('mismatch-error');
                clientSideValidation.functions.showFieldError($passwordConfirmField[0], passwordMismatchMsg);
            }
        }

        // Validate customerType "other" field if clubMember is checked
        if (clubMemberChecked) {
            var $selectedCustomerTypeRadio = $('input[name*="customerType"]:checked');
            if ($selectedCustomerTypeRadio.length > 0 && $selectedCustomerTypeRadio.val() === 'other') {
                var $customerTypeOtherField = $('#customer-type-other-text');
                if ($customerTypeOtherField.length > 0 && $customerTypeOtherField.is(':visible') && (!$customerTypeOtherField.val() || $customerTypeOtherField.val().trim() === '')) {
                    isValid = false;
                    var customerTypeOtherErrorMsg = $customerTypeOtherField.data('missing-error') || 'Must not be blank';
                    clientSideValidation.functions.showFieldError($customerTypeOtherField[0], customerTypeOtherErrorMsg);
                }
            }
        }
    }

    // Validate "other" fields in current step
    var otherFieldsValid = registrationFormHelpers.validateOtherFields($currentStep);
    if (!otherFieldsValid) {
        isValid = false;
    }

    return isValid;
}

/**
 * Initialize form
 */
function initializeForm() {
    if (!$registrationForm || $registrationForm.length === 0) {
        return;
    }

    currentStep = 1;
    selectedCustomerType = null;
    clubMemberChecked = $('#clubMember').is(':checked');

    $registrationForm[0].reset();
    clientSideValidation.functions.clearForm($registrationForm[0]);

    // Show step 1, hide others
    showStep(1);

    // Initialize journey selection visibility
    var $journeySelectionWrapper = $('.journey-selection-wrapper');
    if (clubMemberChecked) {
        $journeySelectionWrapper.removeClass('visually-hidden').addClass('show');
        $('input[name*="customerType"]').prop('disabled', false);
        $('#customer-type-other-text').prop('disabled', false);
    } else {
        $journeySelectionWrapper.removeClass('show').addClass('visually-hidden');
        $('input[name*="customerType"]').prop('disabled', true);
        $('#customer-type-other-text').prop('disabled', true);
    }
}

var register = function () {
    $registrationForm = $('#registration-form');
    if ($registrationForm.length === 0) {
        return;
    }

    $continueButton = $('.continue-button');
    $backButton = $('.back-button');
    $createAccountButton = $('.create-account-button');

    // Club Member checkbox change handler
    $(document).on('change', '#clubMember', function () {
        var $journeySelectionWrapper = $('.journey-selection-wrapper');
        var $journeyOtherGroup = $('.journey-other-group');
        var isChecked = $(this).is(':checked');

        clubMemberChecked = isChecked;

        // Only show journey selection wrapper if we're on step 1 and checkbox is checked
        if (isChecked && currentStep === 1) {
            $journeySelectionWrapper.removeClass('visually-hidden').addClass('show');
            $('input[name*="customerType"]').prop('disabled', false);
            $('#customer-type-other-text').prop('disabled', false);
            updateButtons(1);
        } else {
            // Hide journey selection wrapper
            $journeySelectionWrapper.removeClass('show').addClass('visually-hidden');
            $journeyOtherGroup.removeClass('show').addClass('visually-hidden');
            $('input[name*="customerType"]').prop('checked', false).prop('disabled', true);
            $('#customer-type-other-text').prop('disabled', true).val('');
            selectedCustomerType = null;
            updateButtons(1);
        }
    });

    // Initialize journey form handlers with step-aware logic
    // Note: showJourneyFieldsOnChange is false because registration uses showStep() for navigation
    registrationFormHelpers.handleCustomerTypeChange($registrationForm, {
        currentStep: currentStep,
        showJourneyFieldsOnChange: false,
        onChangeCallback: function (customerType) {
            selectedCustomerType = customerType;
            updateButtons(1);
        }
    });

    // Set up common event handlers (other fields, sell creations)
    registrationFormHelpers.initializeJourneyFormHandlers($registrationForm, {
        currentStep: currentStep
    });

    // Continue button handler
    $(document).on('click', '.continue-button', function (e) {
        e.preventDefault();

        if (!validateCurrentStep()) {
            return;
        }

        if (currentStep === 1) {
            if (selectedCustomerType === 'homebaker' || selectedCustomerType === 'other') {
                currentStep = 3;
                showStep(3);
            } else {
                currentStep = 2;
                showStep(2, selectedCustomerType);
            }
        } else if (currentStep === 2) {
            currentStep = 3;
            showStep(3);
        }

        // Scroll to top of page (header) after step change
        $('html, body').animate({
            scrollTop: 0
        }, 400);
    });

    // Back button handler
    $(document).on('click', '.back-button', function (e) {
        e.preventDefault();

        if (currentStep === 3) {
            if (selectedCustomerType === 'homebaker' || selectedCustomerType === 'other') {
                currentStep = 1;
            } else {
                currentStep = 2;
            }
            showStep(currentStep, selectedCustomerType);
        } else if (currentStep === 2) {
            currentStep = 1;
            showStep(1);
        }
    });

    initializeForm();
};

// API methods for login.js
register.getCurrentStep = function () {
    if (currentStep === 1) {
        return 'initial';
    }
    if (currentStep === 2) {
        return 'step2-' + selectedCustomerType;
    }
    return 'step3';
};

register.isClubMemberChecked = function () {
    if ($('#clubMember').length > 0) {
        clubMemberChecked = $('#clubMember').is(':checked');
    }
    return clubMemberChecked;
};

register.goToStep1 = function () {
    if (!$registrationForm || $registrationForm.length === 0) {
        return;
    }

    // Update current step
    currentStep = 1;

    // Ensure clubMemberChecked is up to date
    if ($('#clubMember').length > 0) {
        clubMemberChecked = $('#clubMember').is(':checked');
    }

    // Show step 1 and hide others
    showStep(1);

    // Show journey selection wrapper if club member is checked
    var $journeySelectionWrapper = $('.journey-selection-wrapper');
    if (clubMemberChecked) {
        $journeySelectionWrapper.removeClass('visually-hidden').addClass('show');
        $('input[name*="customerType"]').prop('disabled', false);
        $('#customer-type-other-text').prop('disabled', false);
    } else {
        $journeySelectionWrapper.removeClass('show').addClass('visually-hidden');
    }

    // Show journey-other-group if "other" is selected
    if (selectedCustomerType === 'other') {
        var $journeyOtherGroup = $('.journey-other-group');
        $journeyOtherGroup.removeClass('visually-hidden').addClass('show');
    }
};

register.validateCurrentStep = validateCurrentStep;

module.exports = register;
